import ModalLayout, { DockPosition } from "components/ModalLayout";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import { useContext } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import Button from "components/Button";
import SearchEntities from "components/SearchEntities";
import { useTranslation } from "react-i18next";
const AddClientInClientsModal = () => {
  const { t } = useTranslation();

  const { modals, setModals } = useContext(ModalsManagerContext);

  const closeModal = () => {
    setModals({ ...modals, hide: true });
  };

  const handleSave = () => {};

  return (
    <ModalLayout
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
      name="addClient"
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {t("modals.newContact")}
          <CloseIcon
            onClick={() => {
              closeModal();
            }}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <SearchEntities
            label={t("columns.entity")}
            doNotRemove
            removeFocus
            onChoose={() => {
              // setMain(entity);
            }}
          />
        </div>
        <div className={styles.buttons}>
          <Button onClick={handleSave} text={t("common.add")} />
        </div>
      </div>
    </ModalLayout>
  );
};

export default AddClientInClientsModal;
